import { ComponentType } from '../ui/shared/enums/ComponentType';
import { VisualStyle } from '../ui/shared/enums/VisualStyle';

/**
 * Represents the raw structure of link data as received from the WordPress API.
 *
 * This interface is designed specifically for WordPress and may need to be
 * adapted if the data source changes in the future.
 */
export interface WordPressMenuItemDTO {
  /** Unique identifier for the link, as provided by WordPress. */
  ID: number;

  /** The title of the post or page, typically used as link text. */
  post_title: string;

  /** The slug or name of the post, often used in URL paths. */
  post_name: string;

  /** The full URL to the link target. */
  url: string;

  /** The position of this link in the menu, according to WordPress. */
  menu_order: number;

  /** ID of the parent menu item, used for hierarchical navigation structures. */
  menu_item_parent: string;

  /** Type of the link, such as internal, external, or email link. */
  link_type: ComponentType;

  /** Visual visual style of the link, such as default or highlighted. */
  variant: VisualStyle;

  /** Indicates if this link is part of a submenu in the WordPress structure. */
  is_submenu: boolean;
}

/**
 * Default configuration for WordPressMenuItemDTO, providing baseline values for link data.
 */
export const defaultWordPressMenuItemDTO: Partial<WordPressMenuItemDTO> = {
  ID: 0,
  post_title: '',
  post_name: '',
  url: '',
  menu_order: 0,
  menu_item_parent: '0',
  link_type: ComponentType.Internal, // Using enum value
  variant: VisualStyle.Default, // Using enum value
  is_submenu: false
};

/**
 * Placeholder configuration for WordPressMenuItemDTO, useful for testing or development.
 */
export const placeholderWordPressMenuItemDTO: Partial<WordPressMenuItemDTO> = {
  ID: 1,
  post_title: 'Some Text For The Link',
  post_name: 'some-text-for-the-link',
  url: '/some-text-for-the-link',
  menu_order: 1,
  menu_item_parent: '12',
  link_type: ComponentType.Internal, // Using enum value
  variant: VisualStyle.Underlined, // Using enum value
  is_submenu: true
};
